import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import Autocomplete from '@mui/material/Autocomplete';
import Spinner from 'src/components/Spinner/Spinner';
import {
  getCustomerCategories,
  setValuesFormAddCustomerCategories,
  clearAllCustomerCategoriesList,
} from 'src/actions/customerCategoriesActions';
import {
  getAllCategoriesList,
  clearContactCategoriesList,
  setContactCategoriesQuery,
} from 'src/actions/contactSettingsActions';
import { CONTACT_CATEGORY } from 'src/constants';

function AddCategoryModal({
  classes,
  loading,
  attachedCategories = [],
  selectedCategories = [],
}) {
  const dispatch = useDispatch();
  const {
    categories,
  } = useSelector((state) => state?.contactSettings || {});

  const attachedCategoriesIds = attachedCategories.map(({ contactCategory }) => contactCategory.id);
  const categoriesList = categories && categories.filter((category) => !attachedCategoriesIds.includes(category.id));

  const handleOnChange = (event, value) => {
    dispatch(setValuesFormAddCustomerCategories({
      selectetCategoriesToAdd: value,
    }));
  };

  useEffect(() => {
    dispatch(setContactCategoriesQuery({
      status: CONTACT_CATEGORY.CONTACT_CATEGORY_SETTINGS_STATUS.ACTIVE,
    }));
    dispatch(getCustomerCategories(true));
    dispatch(getAllCategoriesList(true));

    return () => {
      dispatch(clearContactCategoriesList());
      dispatch(clearAllCustomerCategoriesList());
      dispatch(setContactCategoriesQuery(false));
    };
  }, [dispatch]);

  return (
    <div className={classes.form}>
      <Spinner
        loading={loading}
        positionType="absolute"
      />
      <Grid
        container
        spacing={5}
        className={`${classes.groupLabelText} mt0 semiBold`}
      >
        <Grid
          xs={12}
          className="pt0"
        >
          <p className="text-style-small-1">
            Enter and/or Select one or more categories to add to the contact.
          </p>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={8}
      >
        <Grid xs={12}>
          <Autocomplete
            renderInput={(params) => (
              <TextField
                label="Enter & Select Categories"
                fullWidth
                {...params}
              />
            )}
            value={selectedCategories}
            options={categoriesList}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={(option) => option.name}
            onChange={handleOnChange}
            disabled={loading}
            disableCloseOnSelect
            filterSelectedOptions
            clearOnEscape
            multiple
          />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={5}
        className={`${classes.groupLabelText} mt0 semiBold`}
      >
        <Grid xs={12}>
          <p className="text-style-small-1">
            Note: If a category is not in this list, go to the CP Contact Settings screen, Categories tab. Add the category, then return here to add it to the contact.
          </p>
        </Grid>
      </Grid>
    </div>
  );
}

AddCategoryModal.propTypes = {
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  attachedCategories: PropTypes.array,
  selectedCategories: PropTypes.array,
};

export default AddCategoryModal;
